
import request from "@/utils/request";



//公众号登录 获取token
export function mpLoginApi(data) {
  return request({
    url: '/api/Users/loginByMp',
    method: 'post',
    data: data
  })
}


//查询用户信息 是否注册
export function QueryUserIsBindApi() {
  return request({
    url: '/api/Users/userInfo',
    method: 'get'
  })
}


//获取微信公众号sdk配置
export function getWechatConfig(url) {
  return request({
    url: '/api/MpBase/jssdkConfig?url='+url,
    method: 'get'
  })
}

